class MegaMenu extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(evt) {
        const linkElement = evt.target.closest('[data-link]');
        if (linkElement) {
            const linkValue = linkElement.dataset.link;
            this.toggleVisible(linkValue);

            const oldLink = this.querySelector('[data-link].selected');
            oldLink.classList.remove('selected');
            linkElement.classList.add('selected');
        }
    }

    toggleVisible(link) {
        const containers = this.querySelectorAll('[data-parent-link]');

        containers.forEach((el) => el.classList.toggle('hidden', el.dataset.parentLink != link));
    }
}

customElements.define('mega-menu', MegaMenu);
